import { Option } from '@components/_shared/select';
import React from 'react';
import { MinMaxType } from '@utils/types/searchListingsContext';
import { splitByCommas } from '@utils/helpers';
import { toDollars } from '@utils/money';

export const bedroomsOptions: Option[] = [
  { label: 'Studio', value: 0 },
  { label: '1 Bedroom', value: 1 },
  { label: '2 Bedrooms', value: 2 },
  { label: '3 Bedrooms', value: 3 },
  { label: '4 Bedrooms', value: 4 },
  { label: '5 Bedrooms', value: 5 },
];

export const guestsOptions: Option[] = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
];

export const renderBedroomsValue = (value: MinMaxType) => {
  if (!value?.min && !value?.max) {
    return <span>Bedrooms</span>;
  }

  if (value.min && value.max) {
    return (
      <span>
        {value.min} - {value.max} Bedrooms
      </span>
    );
  }

  if (value.min) {
    return <span>{value.min} Bedrooms+</span>;
  }

  return <span>{value.max} Bedrooms-</span>;
};

const formatPrice = (priceToFormat?: string | number) => {
  if (!priceToFormat) {
    return 'NA';
  }
  const price = +priceToFormat;
  if (price >= 1000) {
    return `${splitByCommas(toDollars(price / 1000, 0))}k`;
  }
  return `${splitByCommas(toDollars(price, 0))}`;
};

export const renderPriceValue = (value: MinMaxType, isMonthly = false) => {
  if (!value?.min && !value?.max) {
    return <span>{isMonthly ? 'Monthly Price' : 'Price'}</span>;
  }

  if (value.min && value.max) {
    return (
      <span>
        {formatPrice(value.min)} - {formatPrice(value.max)}
      </span>
    );
  }

  if (value.min) {
    return <span>{formatPrice(value.min)}+</span>;
  }

  return <span>{formatPrice(value.max)}-</span>;
};
